/**
 * The signed-in workforce session and selected clinic, for module-level API
 * clients that cannot take them as constructor arguments. Set by the auth
 * boundary; never creates a second auth client or persists the token.
 */
let accessToken: (() => Promise<string>) | undefined;
let activeSiteId: string | undefined;

export function setWorkforceAccessTokenProvider(provider: (() => Promise<string>) | undefined) {
  accessToken = provider;
}

export function setWorkforceSiteId(siteId: string | undefined) {
  activeSiteId = siteId;
}

/** The registered provider; it may remain installed while signed out and refuses without a session. */
export function workforceAccessToken(): (() => Promise<string>) | undefined {
  return accessToken;
}

/** The clinic the workforce user selected, falling back to the build's configured clinic. */
export function workforceSiteId(): string | undefined {
  return activeSiteId ?? import.meta.env.VITE_CLINICAL_SITE_ID;
}
